<template>
  <div>
    <van-loading type="spinner" color="#1989fa"/>
  </div>
</template>
<script>
export default {
  name:'loadVue',
    data() {
        return {
            
        }
    },

}
</script>
<style lang="less" scoped>
.van-loading{
    height: 5rem;
    line-height: 5rem;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    .van-loading__spinner{
        width: 1.3rem;
        height: 1.3rem;
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/common/loading.vue